import {
  Badge,
  FlexBox,
  Icon,
  IconNames,
  Tooltip,
} from '@dixa/lib-shared-habla';
import { AiDraftType } from 'lib-knowledge-management-common/graphql';

import s from './suggestionTypeBadge.module.scss';

/** Also the preview's labels, which name the same draft without an icon. */
export const TYPE_LABEL: Record<AiDraftType, string> = {
  [AiDraftType.NewArticle]: 'New article',
  [AiDraftType.ArticleUpdate]: 'Article update',
};

const TYPE_ICON: Record<AiDraftType, IconNames> = {
  [AiDraftType.NewArticle]: 'plus',
  [AiDraftType.ArticleUpdate]: 'pen',
};

/**
 * Which kind of draft a row holds. The queue lists both kinds in one list
 * ordered by date, so this is the only thing distinguishing them.
 *
 * A draft for internal only collections gets a lock on its right, as internal
 * only collections show in the collections sidebar.
 */
export function SuggestionTypeBadge({
  type,
  internalOnly = false,
}: {
  type: AiDraftType;
  internalOnly?: boolean;
}): JSX.Element {
  return (
    <FlexBox alignItems="center" gap="100">
      <Badge variant="primary" size="small" icon={TYPE_ICON[type]}>
        {TYPE_LABEL[type]}
      </Badge>
      {internalOnly && (
        <Tooltip content="Internal only" wrapProps={{ className: s.lock }}>
          <Icon name="lock" size={16} aria-label="Internal only" />
        </Tooltip>
      )}
    </FlexBox>
  );
}
